var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form-item',[_c('a-radio-group',{directives:[{name:"decorator",rawName:"v-decorator",value:(_vm.decorator),expression:"decorator"}],on:{"change":_vm.handleMachineChange}},_vm._l((_vm.machineOptions),function(opt){return _c('a-radio-button',{key:opt.value,attrs:{"value":opt.value}},[_vm._v(_vm._s(opt.text))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }